const VisualStatic = require('visual-static');
const FormFields = require('form-fields');

class Form extends VisualStatic {
  init() {
    this.orderOfFormFields = ['payer_company_name1', 'payer_address1', 'payer_address2', 'payer_city', 'payer_state', 'payer_zipcode', 'payer_phone', 'payer_country', 'payer_tin_type', 'payer_tin', 'payee1_tin_type', 'payee1_tin', 'payee1_name', 'payee1_address1', 'payee1_address2', 'payee1_city', 'payee1_state', 'payee1_zipcode', 'payee1_country', 'payee1_accountnumber', 'payee1_fatca_filing', 'payee1_2ndtinnotice', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_direct_sales', 'payee1_sub_payments_div_intr', 'payee1_crop_ins', 'payee1_gross_paid_attorney', 'payee1_fish_resale', 'payee1_section409a_deferrals', 'payee1_excess_golden_parachut', 'payee1_section409a_income', 'payee1_statetax_with1', 'payee1_state1_name', 'payee1_state1_id', 'payee1_state_income1', 'payee1_statetax_with2', 'payee1_state2_name', 'payee1_state2_id', 'payee1_state_income2'];

    this.removeLabelsFromFields = ['payer_tin', 'payee1_tin', 'payee1_rents', 'payee1_royalties', 'payee1_other_income', 'payee1_fedtaxwith', 'payee1_fishingboat_proceeds', 'payee1_medical_healthcare_payments', 'payee1_sub_payments_div_intr', 'payee1_crop_ins', 'payee1_excess_golden_parachut', 'payee1_gross_paid_attorney', 'payee1_fish_resale', 'payee1_statetax_with1', 'payee1_statetax_with2', 'payee1_state_income1', 'payee1_state_income2', 'payee1_section409a_income', 'payee1_section409a_deferrals', 'payee1_accountnumber'];

    this.initOnReactComponentsMounted();
  }

  initBuilderOnReactComponentsMounted() {
    this.initBuilder();
    VisualStatic.setUpIowaBENInput();

    // Set the correct order of fields
    VisualStatic.setTabOrder(this.orderOfFormFields);

    VisualStatic.setPlaceholders(this.removeLabelsFromFields);

    const eFileButton = document.getElementById('efileDocument');
    // Hide the eFiling option for unpaid users
    if (!window.SessionManager.isPaidUser && eFileButton) {
      eFileButton.style.display = 'none';
    }

    // Attach button events
    VisualStatic.initExportPDF();

    // [E-file] Context on the E-file flow at this stage:
    // When the e-filing button is clicked, we validate that required fields are added and
    // that certain fields have passed regex validation. Once all specified fields pass validation,
    // we should save the document session and redirect to the taxFiling page.
    if (eFileButton) {
      eFileButton.addEventListener('click', (e) => {
        const requiredFields = [
          'payer_tin',
          'payer_company_name1',
          'payer_address1',
          'payer_city',
          'payer_state',
          'payer_zipcode',
          'payer_country',
          'payer_phone',
          'payee1_tin',
          'payee1_name',
          'payee1_address1',
          'payee1_city',
          'payee1_state',
          'payee1_zipcode',
          'payee1_country',
          'payee1_accountnumber',
        ];

        const hasRequiredFields = FormFields.checkRequiredFields(requiredFields);
        if (!hasRequiredFields) {
          e.preventDefault();
          return false;
        }

        const currencyRegex = { regex: new RegExp('^[\\d]+(.\\d{2})?$'), message: 'numbers only, period must be followed by two numbers' };
        const stateRegex = { regex: new RegExp('^[a-zA-Z]{2}$'), message: 'exactly 2 letters' };
        const tinRegex = { regex: new RegExp('^\\d{9}$'), message: 'exactly 9 numbers' };
        const accountNumberRegex = { regex: new RegExp('^.{1,20}$'), message: '20 or less characters' };
        const regexValidations = {
          payer_tin: tinRegex,
          payee1_tin: tinRegex,
          payer_state: stateRegex,
          payee1_state: stateRegex,
          payee1_state1_name: stateRegex,
          payee1_state2_name: stateRegex,
          payee1_accountnumber: accountNumberRegex,
          payee1_rents: currencyRegex,
          payee1_royalties: currencyRegex,
          payee1_other_income: currencyRegex,
          payee1_fedtaxwith: currencyRegex,
          payee1_fishingboat_proceeds: currencyRegex,
          payee1_fish_resale: currencyRegex,
          payee1_medical_healthcare_payments: currencyRegex,
          payee1_sub_payments_div_intr: currencyRegex,
          payee1_crop_ins: currencyRegex,
          payee1_excess_golden_parachut: currencyRegex,
          payee1_gross_paid_attorney: currencyRegex,
          payee1_statetax_with1: currencyRegex,
          payee1_statetax_with2: currencyRegex,
          payee1_state_income1: currencyRegex,
          payee1_state_income2: currencyRegex,
          payee1_section409a_deferrals: currencyRegex,
          payee1_section409a_income: currencyRegex,
        };
        const validFields = FormFields.validateFields(regexValidations);
        if (!validFields) {
          e.preventDefault();
          return false;
        }

        // Validations passed, save and submit
        return window.SessionManager.save(() => (true));
      });
    }
  }
}

module.exports = Form;



// WEBPACK FOOTER //
// ./src-assets/js/form-1099-misc-efile-2021.js